import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Asset, SubAsset } from '../../../../models/asset.model';

@Component({
  selector: 'mtm-variant-dropdown-menu',
  templateUrl: './variant-dropdown-menu.component.html',
  styleUrl: './variant-dropdown-menu.component.scss',
  standalone: false,
})
export class VariantDropdownMenuComponent {
  @ViewChild('dropdownRef', { static: false }) dropdownRef!: NgbDropdown;

  @Input() content!: Asset & { deliveryDate: string };
  @Input() variant!: SubAsset & { deliveryDate: string };
  @Input() funnel!: string;

  @Output() editVariant = new EventEmitter<{ funnel: string; content: any; isVariant?: boolean }>();
  @Output() duplicateVariant = new EventEmitter<{ content: any; variant: any }>();
  @Output() deleteVariant = new EventEmitter<{ content: any; variant: any }>();

  public onEditVariant(): void {
    this.editVariant.emit({ funnel: this.funnel, content: this.content, isVariant: true });
    this.closeDropdown();
  }

  public onDuplicateVariant(): void {
    this.duplicateVariant.emit({ content: this.content, variant: this.variant });
    this.closeDropdown();
  }

  public onDeleteVariant(): void {
    this.deleteVariant.emit({ content: this.content, variant: this.variant });
    this.closeDropdown();
  }

  private closeDropdown(): void {
    if (this.dropdownRef && this.dropdownRef.isOpen()) {
      this.dropdownRef.close();
    }
  }
}
